import React from 'react';
import ProfilePictureWithUpload from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Profile/ProfilePictureWithUpload';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import AuthContainer from 'src/components/SignIn/AuthContainer';
import LogoContainer from 'src/components/SignIn/LogoContainer';
import { useAppSelector } from 'src/utils/Hooks';
import AuthButton from 'src/components/SignIn/AuthButton';
import Box from '@mui/material/Box';
import { AnimatedEllipsis } from 'src/components/common/Loading/AnimatedEllipsis';
import * as serverProxy from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/serverProxy';
import { useDispatch } from 'react-redux';
import { setErrorMessage } from 'src/store/modules/auth/operations';
import AuthTextButton from 'src/components/SignIn/AuthTextButton';
import userSkipImage from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/serverProxy/userSkipImage';
import { NewPictureAddPlusIcon } from 'src/components/SvgIcons/SvgIcons';

/**
 * Component that will render user to upload profile image in sign in container.
 *
 */
const UploadProfile = ({
  email,
  clearErrorMessage,
  handleFormSubmit
}: {
  email: string;
  clearErrorMessage: () => void;
  setErrorMessage: (msg: string) => void;
  handleFormSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const app = useAppSelector((state) => state.app);
  const dispatch = useDispatch();
  const [isFormSubmitted, setIsFormSubmitted] = React.useState(false);
  const [profilePicture, setProfilePicture] = React.useState<File | null>(null);

  return (
    <AuthContainer style={{ height: '732px', padding: '56px' }}>
      <LogoContainer title={app.displayName} />
      <p
        style={{
          fontSize: '34px',
          fontWeight: 600,
          marginTop: '16px',
          marginBottom: '40px',
          textAlign: 'center',
          fontFamily: 'Geist'
        }}
      >
        Upload profile photo
      </p>
      <Flex justifyContent="center" marginBottom="48px">
        <ProfilePictureWithUpload
          email={email}
          appProfileIconProps={{
            size: 256,
            backgroundColor: '#E6E9ED'
          }}
          fabSize={56}
          uploadImage={(file, userEmail) => {
            setProfilePicture(file);
            serverProxy.uploadUserImage(file, userEmail);
            clearErrorMessage();
          }}
          fabIcon={<NewPictureAddPlusIcon style={{ width: '22px' }} />}
        />
      </Flex>
      <AuthButton
        type="submit"
        onClick={(event) => {
          if (!profilePicture) {
            event.preventDefault();
            dispatch(setErrorMessage('Please upload a profile photo to complete your account setup.'));
          } else {
            setIsFormSubmitted(true);
            handleFormSubmit(event);
          }
        }}
      >
        {isFormSubmitted ? (
          <Box display="flex" flexDirection="row" maxHeight="100%" alignItems="center" justifyContent="center">
            Uploading photo
            <AnimatedEllipsis width={40} height={40} style={{ margin: 0, transform: 'translate(-8px,5px)' }} />
          </Box>
        ) : (
          <>Upload photo</>
        )}
      </AuthButton>
      <AuthTextButton
        onClick={(event) => {
          setIsFormSubmitted(true);
          userSkipImage();
          handleFormSubmit(event);
        }}
      >
        Create account without photo
      </AuthTextButton>
    </AuthContainer>
  );
};

export default UploadProfile;
